export const loadingMessageStyle = (theme) => ({
  root: {
    paddingTop: 10,
    paddingBottom: 15,
    textAlign: theme.wrappers.alignCenter,
  },
});
